import React, { createContext, useContext, useMemo, useState } from 'react';
import { matchPath } from 'react-router-dom';

const AssistantContext = createContext({
  formContext: null,
  setFormContext: () => {},
});

const ROUTE_CONTEXTS = [
  { pattern: '/', title: 'Dashboard', workflow: 'dashboard' },
  { pattern: '/complaints', title: 'Complaints', workflow: 'complaints' },
  { pattern: '/complaint/:id', title: 'Complaint Detail', workflow: 'complaint_detail' },
  { pattern: '/violations', title: 'Violations', workflow: 'violations' },
  { pattern: '/violation/:id', title: 'Violation Detail', workflow: 'violation_detail' },
  { pattern: '/inspections', title: 'Inspections', workflow: 'inspections' },
  { pattern: '/my-inspections', title: 'My Inspections', workflow: 'inspections' },
  { pattern: '/inspection/:id', title: 'Inspection Detail', workflow: 'inspection_detail' },
  { pattern: '/inspections/:id/checklist', title: 'Inspection Checklist', workflow: 'inspection_checklist' },
  { pattern: '/inspections/:id/checklist/review', title: 'Inspection Review', workflow: 'inspection_review' },
  { pattern: '/citations', title: 'Citations', workflow: 'citations' },
  { pattern: '/citation/:id', title: 'Citation Detail', workflow: 'citation_detail' },
  { pattern: '/applications', title: 'License Applications', workflow: 'applications' },
  { pattern: '/applications/:id', title: 'Application Detail', workflow: 'application_detail' },
  { pattern: '/permit-applications', title: 'Permit Applications', workflow: 'permit_applications' },
  { pattern: '/permit-applications/:id', title: 'Permit Application Detail', workflow: 'permit_application_detail' },
  { pattern: '/permits', title: 'Permits', workflow: 'permits' },
  { pattern: '/permit/:id', title: 'Permit Detail', workflow: 'permit_detail' },
  { pattern: '/licenses', title: 'Licenses', workflow: 'licenses' },
  { pattern: '/license/:id', title: 'License Detail', workflow: 'license_detail' },
  { pattern: '/codes', title: 'Codes', workflow: 'code_lookup' },
  { pattern: '/code/:id', title: 'Code Detail', workflow: 'code_lookup' },
  { pattern: '/photo-bank', title: 'Photo Bank', workflow: 'photo_bank' },
  { pattern: '/cases', title: 'Cases', workflow: 'cases' },
  { pattern: '/case/:id', title: 'Case Detail', workflow: 'case_detail' },
  { pattern: '/contacts', title: 'Contacts', workflow: 'contacts' },
  { pattern: '/contacts/:id', title: 'Contact Detail', workflow: 'contact_detail' },
  { pattern: '/admin/workload', title: 'Workload Balancing', workflow: 'staff_workload' },
  { pattern: '/admin/email-dashboard', title: 'Email Dashboard', workflow: 'email_dashboard' },
  { pattern: '/notifications', title: 'Notifications', workflow: 'notifications' },
];

export function AssistantProvider({ children }) {
  const [formContext, setFormContext] = useState(null);
  const value = useMemo(() => ({ formContext, setFormContext }), [formContext]);
  return <AssistantContext.Provider value={value}>{children}</AssistantContext.Provider>;
}

export function useAssistantContext() {
  return useContext(AssistantContext);
}

export function getAssistantRouteContext(pathname = '/') {
  const path = pathname || '/';
  const match = ROUTE_CONTEXTS.find((route) => matchPath({ path: route.pattern, end: true }, path));
  if (!match) {
    return { path, title: 'CodeSoft', workflow: 'general' };
  }
  return { path, title: match.title, workflow: match.workflow };
}

